import { selectAll } from '../helpers';

export default () => {
  /* eslint-disable */
  class Accordion {
    constructor(heading) {
      this.heading = heading;
    }

    showOne() {
      if (this.heading) {
        const accordionHeading = selectAll(this.heading);
        accordionHeading.forEach((item, key) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            accordionHeading.forEach(element => {
              element.classList.contains('active') ? element.classList.remove('active') : null;
            });

            item.classList.add('active');
          });
        });
      }
    }
  }

  const accordionFooter = new Accordion('');
  accordionFooter.showOne();

  const accordionHeader = new Accordion('.header--mobile nav.menu--main > ul.menu > li.menu-item--expanded > a');
  accordionHeader.showOne();
};

/* eslint-enable */
